<template>
  <FormItem
    label="通訊地址"
    class="address-select clearfix"
    :label-width="labelWidth"
    :prop="prop"
  >
    <Select
      :value="address.city"
      size="large"
      placeholder="選擇縣市"
      @on-change="handleCityChange($event)"
    >
      <Option
        v-for="option in cities"
        :key="option.name"
        :value="option.name"
        :label="option.name"
      />
    </Select>
    <Select
      :value="address.area"
      placeholder="選擇區域"
      size="large"
      @on-change="handleAreaChange($event)"
    >
      <Option 
        v-for="option in areas"
        :key="option.name"
        :value="option.name"
        :label="option.name"
      />
    </Select>
    <Input 
      :value="address.road"
      type="text"
      size="large"
      class="pull-right"
      @on-change="handleRoadChange($event)"
    />
    <p v-if="tips">{{ tips }}</p>
  </FormItem>
</template>

<script>
  import { FormItem, Select, Option, Input } from 'iview';
  import cities from '@/staticData/addressDropdown';

  export default {
    components: { FormItem, Select, Option, Input },
    props: {
      prop: {
        type: String,
        default: ''
      },
      labelWidth: {
        type: Number,
        default: null
      },
      value: {
        type: Object,
        default: () => ({ city: '', area: '', address: '' })
      },
      tips: {
        type: String,
        default: null
      }
    },
    computed: {
      cities() {
        return cities;
      },
      areas() {
        const { city } = this.address;
        if (!city) return null;
        return cities.find(c => c.name === city).areas;
      },
      address() {
        return this.value;
      }
    },
    methods: {
      handleCityChange(val) {
        const address = { ...this.value, zip: '', city: val, area: '' };
        this.$emit('input', address);
      },
      handleAreaChange(val) {
        if (!val) return;
        const { areas } = this;
        const { zip } = areas.find(a => a.name === val);
        const address = { ...this.value, zip, area: val };
        this.$emit('input', address);
      },
      handleRoadChange(e) {
        const address = { ...this.value, road: e.target.value };
        this.$emit('input', address);
      }
    }
  };
</script>